<template>
  <v-layout align-start>
    <v-flex>
      <v-data-table
        :headers="headers"
        :items="ClientesFuturo"
        :search="search"
        sort-by="calories"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Verificación Seguros Futuro</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-btn outlined icon color="green" @click="listar()"
              ><v-icon class="fa fa-sync-alt"></v-icon
            ></v-btn>
            <v-spacer></v-spacer>
            <v-text-field
              class="text-xs-center"
              v-model="search"
              append-icon="search"
              label="Busqueda"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
          </v-toolbar>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-icon small class="mr-2" @click="verDetalles(item)">
            tab
          </v-icon>
        </template>
      </v-data-table>
      <!-- PreLoader -->
      <v-overlay v-model="overlay" z-index="0">
        <lottie-player
          v-if="true"
          src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
          background="transparent"
          speed="1"
          style="width: 300px; height: 300px;"
          loop
          autoplay
        ></lottie-player>
      </v-overlay>

      <v-snackbar v-model="snackError" color="cyan darken-2" top
        >Sucedio algun error, verificar estado de conexión.</v-snackbar
      >
    </v-flex>
    <v-dialog v-model="dialog" max-width="700px">
      <v-card>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" class="ma-0">
                <v-text-field
                  v-model="Contratante"
                  label="CONTRATANTE"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="4" class="mt-n5">
                <v-text-field
                  v-model="Cnpoliza"
                  label="POLIZA"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="4" class="mt-n5">
                <v-text-field
                  v-model="Vig_inicial"
                  label="VIGENCIA INCIAL"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="4" class="mt-n5">
                <v-text-field
                  v-model="Vig_final"
                  label="VIGENCIA FINAL"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="4" class="mt-n5">
                <v-text-field
                  v-model="Tipo"
                  label="TIPO"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="4" class="mt-n5">
                <v-text-field
                  v-model="Marca"
                  label="MARCA"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="4" class="mt-n5">
                <v-text-field
                  v-model="Modelo"
                  label="MODELO"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="4" class="mt-n5">
                <v-text-field
                  v-model="Cano"
                  label="AÑO"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="4" class="mt-n5">
                <v-text-field
                  v-model="Xplaca"
                  label="PLACA"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="4" class="mt-n5">
                <v-text-field
                  v-model="Motor"
                  label="MOTOR"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="6" class="mt-n5">
                <v-text-field
                  v-model="Chasis"
                  label="CHASIS"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="6" class="mt-n5">
                <v-text-field
                  v-model="Plan"
                  label="PLAN"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="6" class="mt-n5">
                <v-text-field
                  v-model="Uso_vehiculo"
                  label="USO VEHICULO"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="6" class="mt-n5">
                <v-text-field
                  v-model="Estado"
                  label="ESTADO"
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="close">CERRAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      dialog: false,
      ClientesFuturo: [],
      headers: [
        { text: "Opciones", align: "center", value: "action", sortable: false },
        { text: "Contratante", value: "Contratante", sortable: true },
        { text: "Tipo", value: "Tipo", sortable: true },
        { text: "Marca", value: "Marca", sortable: true },
        { text: "Modelo", value: "Modelo", sortable: true },
        { text: "Año", value: "Cano", sortable: true },
        { text: "Placa", value: "Xplaca", sortable: true },
        { text: "Estado", value: "Estado", sortable: true },
      ],
      search: "",
      Contratante: "",
      Cnpoliza: "",
      Vig_inicial: "",
      Vig_final: "",
      Tipo: "",
      Marca: "",
      Modelo: "",
      Cano: "",
      Xplaca: "",
      Motor: "",
      Chasis: "",
      Plan: "",
      Uso_vehiculo: "",
      Estado: "",
      overlay: true,
      snackError: false,
    };
  },

  created() {
    this.listar();
  },

  methods: {
    listar() {
      let me = this;
      me.ClientesFuturo = [];
      me.overlay = true;
      axios
        .get("http://192.168.60.228:9099/Service1.svc/GetListAsistencia")
        .then(function(response) {
          me.ClientesFuturo = response.data;
          if (response.status == 200) {
            me.overlay = false;
          }
        })
        .catch(function(error) {
          console.log("Error", error);
        });
    },
    verDetalles(item) {
      this.limpiar();
      this.Contratante = item.Contratante;
      this.Cnpoliza = item.Cnpoliza;
      this.Vig_inicial = item.Vig_inicial;
      this.Vig_final = item.Vig_final;
      this.Tipo = item.Tipo;
      this.Marca = item.Marca;
      this.Modelo = item.Modelo;
      this.Cano = item.Cano;
      this.Xplaca = item.Xplaca;
      this.Motor = item.Motor;
      this.Chasis = item.Chasis;
      this.Plan = item.Plan;
      this.Uso_vehiculo = item.Uso_vehiculo;
      this.Estado = item.Estado;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.limpiar();
    },
    limpiar() {
      this.Contratante = "";
      this.Cnpoliza = "";
      this.Vig_inicial = "";
      this.Vig_final = "";
      this.Tipo = "";
      this.Marca = "";
      this.Modelo = "";
      this.Cano = "";
      this.Xplaca = "";
      this.Motor = "";
      this.Chasis = "";
      this.Plan = "";
      this.Uso_vehiculo = "";
      this.Estado = "";
    },
  },
};
</script>
